import { useEffect, useState } from "react";
import CollapseCard from "../components/custom/CollapseCard";
import { ToastContainer, toast } from "react-toastify";
import Main from "../components/custom/Main";
import PageContainer from "../components/custom/PageContainer";
import { getAllDropDowns } from "../services/DropDownService";
import { DropDown as DropDownType } from "../types/DropDown";
import { Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../redux/reducers";
import { fetchProjects } from "../redux/actions/projectAction";
import { AppDispatch } from "../redux/store";
import { fetchEmployeesAction } from "../redux/actions/employeeActions";

const DropDown = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [category, setCategory] = useState("");
  const [categoryError, setCategoryError] = useState("");
  const [title, setTitle] = useState("");
  const [titleError, setTitleError] = useState("");
  const [dropdownList, setDropdownList] = useState<DropDownType[]>([]);
  const projects = useSelector((state: StoreState) => state.project);
  const employees = useSelector((state: StoreState) => state.employee);
  useEffect(() => {
    fetchDropDowns();
    dispatch(fetchProjects());
    dispatch(fetchEmployeesAction());
  }, [dispatch]);

  const fetchDropDowns = async () => {
    try {
      const data = await getAllDropDowns();
      console.log("Fetched dropdowns:", data);
      setDropdownList(data);
    } catch (err) {
      console.error("Dropdown fetch error:", err);
      toast.error("Failed to fetch dropdowns");
    }
  };

  return (
    <Main>
      <PageContainer title="DropDown Master">
        <Card>
          <div className="container">
            <div className="row">
              <div className="col-6 mb-3">
                <label className="mt-3 m-2">
                  Category<span className="text-danger">*</span>
                </label>
                <select
                  className="form-control"
                  value={category}
                  onChange={(e) => {
                    setCategory(e.target.value);
                    setCategoryError("");
                    setTitle("");
                  }}
                >
                  <option value="">Select</option>
                  <option value="Project">Project</option>
                  <option value="EmployeeID">EmployeeId</option>
                  <option value="Task">Task</option>
                  <option value="Role">Role</option>
                </select>

                {categoryError && (
                  <div className="text-danger">{categoryError}</div>
                )}
              </div>
            </div>
          </div>
        </Card>

        <CollapseCard title="Dropdown List">
          <div className="container">
            <table className="table table-striped">
              <thead style={{ backgroundColor: "#10296C", color: "#fff" }}>
                <tr>
                  <th>S.No.</th>
                  <th>Title</th>
                </tr>
              </thead>
              <tbody>
                {category === "Project" &&
                  projects.map((project, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{project.name}</td>
                    </tr>
                  ))}
                {category === "EmployeeId" &&
                  employees.map((employee, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{employee.employeeId}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </CollapseCard>
        <ToastContainer position="top-right" />
      </PageContainer>
    </Main>
  );
};

export default DropDown;
